/**
 * Grab the user agent of the current user.
 *
 * @since 0.1.2
 *
 * @returns {string} The user agent as a string.
 */
export default function userAgent() {
	return navigator.userAgent || ''
}
